exports.DOCS_CONTEXT = require.context('./docs', true, /index\.(markdown|mdx)$/i);
exports.DOCS_NAVIGATION = require('./navigation.json');
